import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const claimDrawerAction: UseResourceDrawerOpenDrawerArgs<'Claim'>['action'] = ({
  model,
}) => ({
  label: 'Claim',
  title: model.title,
  content: {
    body: (
      <div className={tw`flex flex-col gap-5`}>
        <ContentCard variant="focal" title="Details">
          <DefinitionList
            items={[
              { label: 'Claim Type', value: model.claimType ?? 'n/a' },
              { label: 'Date of Service', value: model.serviceDate ?? 'n/a' },
              { label: 'ICD-10', value: model.icd10Codes.join(', ') || 'n/a' },
              { label: 'Service Codes', value: model.serviceCodes.join(', ') || 'n/a' },
            ]}
          />
        </ContentCard>
      </div>
    ),
  },
});
